import StorageWrapper from "helpers/storageWrapper";
const LocalStorageUtils = new StorageWrapper(StorageWrapper.Types.Local);
export default LocalStorageUtils;
